var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAllabolagIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    imageRendering: "optimizeQuality",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m122.5 9.5c55.941 0.8605 91.108 28.194 105.5 82 5.174 34.671-4.16 64.671-28 90-23.112 22.111-45.945 44.611-68.5 67.5-1.941 0.743-3.774 0.576-5.5-0.5-0.5-12.662-0.667-25.329-0.5-38-45.136-3.313-75.969-25.98-92.5-68-12.945-45.752-1.1116-83.586 35.5-113.5 16.362-11.175 34.362-17.675 54-19.5zm3 39c24.529 0.0135 43.362 10.347 56.5 31 14.974 33.177 8.14 60.677-20.5 82.5-6.571 3.912-13.571 6.745-21 8.5-31.876 3.804-55.043-8.863-69.5-38-9.4058-31.792-0.5724-56.958 26.5-75.5 8.803-4.9197 18.136-7.753 28-8.5z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m125.5 74.5c20.609 0.117 33.442 10.117 38.5 30 1.331 21.665-8.502 35.165-29.5 40.5-22.311 1.423-36.144-8.743-41.5-30.5-0.3189-22.505 10.514-35.839 32.5-40z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllabolagIcon);
export default __webpack_public_path__ + "static/media/allabolag-icon.fd1541e93f2076d75b539fc38cfbf920.svg";
export { ForwardRef as ReactComponent };